import { createAsyncThunk } from '@reduxjs/toolkit';
import { CountriesApi } from '../../../api/base/Countries';

export const fetchCountries = createAsyncThunk(
  'countries/fetchCountries',
  async (): Promise<Array<any>> => {
    const response = await CountriesApi.getCountries();
    return response.data.data;
  },
);

// export const fetchMovies = createAsyncThunk(
//   `${commonMoviesModule}/fetchMoviesStatus`,
//   async (
//     filters: ICommonMoviesFilters,
//     { rejectWithValue },
//   ): Promise<IGetMoviesData | any> => {
//     try {
//       const response = await moviesApi.getMovies(filters);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   },
// );

export const asyncCountriesActions = {
  fetchCountries,
};
